import { 
  appendText,
  getText, 
} from '../../assets/js/text-renderer';

import './data-manager.scss';
import '../shared/cta/cta';

document.addEventListener('DOMContentLoaded', async () => {
  if (
    DEVELOPMENT || (
    window['__PRERENDER_INJECTED'] && 
    window['__PRERENDER_INJECTED'].render_text)
  ) await loadText();
});

const loadText = async() => {
  const data = await getText('platform/intelek-data-manager')
  const content = data.stories[0].content;
  
  setHeroContent(content);
  setFeaturesContent(content);
  await setCustomCtaContent();

  window.dispatchEvent(
    new CustomEvent('rendered-text', { detail: 'keywords' })
  );
  window.dispatchEvent(
    new CustomEvent('rendered-text', { detail: 'content' })
  );
};

function setHeroContent(content) {
  appendText(content.hero_title, 'hero-title');
  appendText(content.summary, 'summary');
};

function setFeaturesContent(content) {
  appendText(content.features_items[0].title, 'features-items-title-0')
  appendText(content.features_items[0].description, 'features-items-description-0')
  appendText(content.features_items[1].title, 'features-items-title-1')
  appendText(content.features_items[1].description, 'features-items-description-1')
  appendText(content.features_items[2].title, 'features-items-title-2')
  appendText(content.features_items[2].description, 'features-items-description-2')
};

async function setCustomCtaContent() {
  const ctaData = await getText('platform/shared/cta');
  const ctaContent = ctaData.stories[0].content.block[0];

  const customCtaContainer = document.getElementById('custom-cta');
  const customCtaEl = document.createElement('custom-cta');
  customCtaEl.setAttribute('title', ctaContent.title)
  customCtaEl.setAttribute('description', ctaContent.description)
  customCtaEl.setAttribute('primary-button-text', ctaContent.btn_primary)
  customCtaEl.setAttribute('primary-button-url', '/plataforma/start-trial/')
  customCtaEl.setAttribute('secondary-button-text', ctaContent.btn_secondary)
  customCtaEl.setAttribute('secondary-button-url', '/plataforma/book-demo-form/')
  customCtaContainer.appendChild(customCtaEl);

  window.dispatchEvent(
    new CustomEvent("rendered-text", { detail: "cta" })
  );
};

//SCROLL ANIMATION
function lerpColor(a, b, amount) {
  var ah = parseInt(a.replace(/#/g, ''), 16),
    ar = ah >> 16,
    ag = (ah >> 8) & 0xff,
    ab = ah & 0xff,
    bh = parseInt(b.replace(/#/g, ''), 16),
    br = bh >> 16,
    bg = (bh >> 8) & 0xff,
    bb = bh & 0xff,
    rr = ar + amount * (br - ar),
    rg = ag + amount * (bg - ag),
    rb = ab + amount * (bb - ab);

  return '#' + (((1 << 24) + (rr << 16) + (rg << 8) + rb) | 0).toString(16).slice(1);
};

// Reference: http://www/5rocks.com/en/tutorials/speed/animations/

let last_known_scroll_position = 0;
let ticking = false;
let circle = document.getElementsByClassName('circle')[0];

function doSomething(scroll_pos) {
  if (scroll_pos < 860) {
    circle.style.display = 'none';
  } else if (scroll_pos > 860 && scroll_pos < 985) {
    circle.style.display = 'block';
    circle.style.left = `${22.5}%`;
    circle.style.bottom = `${120 - (scroll_pos - 850)}px`;
    circle.style['background-color'] = lerpColor('#e6d9d9', '#ffffff', (scroll_pos - 850) / (985 - 850));
  } else if (scroll_pos > 985 && scroll_pos < 1555) {
    circle.style.display = 'block';
    circle.style.bottom = '-15px';
    circle.style.left = `${22.5 + ((172.2 - 22.5) * (scroll_pos - 985)) / (1555 - 985)}%`;
    circle.style['background-color'] = 'white';
  } else if (scroll_pos > 1555 && scroll_pos < 1690) {
    circle.style.left = '172.2%';
    circle.style.bottom = `${-15 - (scroll_pos - 1555)}px`;
    circle.style.display = 'block';
    circle.style['background-color'] = 'white';
  } else if (scroll_pos > 1690 && scroll_pos < 1820) {
    circle.style.bottom = `${-800 - (scroll_pos - 1690)}px`;
    circle.style.left = '172.2%';
    circle.style.display = 'block';
    circle.style['background-color'] = lerpColor('#e6d9d9', '#ffffff', (scroll_pos - 1700) / (1820 - 1700));
  } else if (scroll_pos > 1820 && scroll_pos < 2500) {
    circle.style['background-color'] = 'white';
    circle.style.bottom = '-935px';
    circle.style.left = `${172.2 - ((172.2 - 22.5) * (scroll_pos - 1820)) / (2500 - 1820)}%`;
    circle.style.display = 'block';
    circle.style['background-color'] = 'white';
  } else if (scroll_pos > 2500 && scroll_pos < 2600) {
    circle.style.left = `${22.5}%`;
    circle.style.bottom = `${-935 - (scroll_pos - 2500)}px`;
    circle.style.display = 'block';
    circle.style['background-color'] = 'white';
  } else {
    circle.style.display = 'none';
  }
};

document.addEventListener('scroll', function (e) {
  last_known_scroll_position = window.scrollY;

  if (!ticking) {
    setTimeout(function () {
      doSomething(last_known_scroll_position);
      ticking = false;
    }, 10);

    ticking = true;
  }
});
